import { render, staticRenderFns } from "./subportion-analysis-side-panel.vue?vue&type=template&id=2d539e23&"
import script from "./subportion-analysis-side-panel.ts?vue&type=script&lang=ts&"
export * from "./subportion-analysis-side-panel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports